module.exports = __webpack_public_path__ + "img/energyConsumptionMgt.dbcd9fda.svg";